import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import themeable from 'zignal-landscape/lib/themeable';
import ThemeProvider from 'zignal-landscape/lib/ThemeProvider';
import { Light } from 'themes';

import TabbedPanes from 'zignal-landscape/lib/TabbedPanes';
import Tabs from 'zignal-landscape/lib/Tabs';
import Tab from 'zignal-landscape/lib/Tab';
import Pane from 'zignal-landscape/lib/Pane';
import Panes from 'zignal-landscape/lib/Panes';

import * as actions from './AdminSettings.ducks';

export const mapStateToProps = (
  (state) => ({
    selectedIndex: state.AdminSettings.selectedIndex,
  })
);

export const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return Object.assign({}, stateProps, dispatchProps, ownProps);
};

class AdminSettings extends Component {

  // TODO: Update logic when migrating to React 17
  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    const { defaultSelectedTab, selectedIndex, handleTabChange } = this.props;
    if (defaultSelectedTab !== selectedIndex) {
      handleTabChange(defaultSelectedTab);
    }
  }

  render() {
    const {selectedIndex, handleTabChange, onTabChange, styles} = this.props;
    const onChange = (tabIndex) => {
      if (selectedIndex !== tabIndex) {
        onTabChange(tabIndex);
        handleTabChange(tabIndex);
      }
    };
    const twitterImportsAvailable = window?.splitHelper?.getTreatment('GNIP_Imports') === 'on';
    return (
      <ThemeProvider theme={Light}>
        <div className={styles.AdminSettings}>
          <TabbedPanes selectedIndex={selectedIndex} onChange={onChange}>
            <Tabs>
              <Tab>Command Center Installations</Tab>
              <Tab>Admin Management</Tab>
              <Tab>Internal Admins</Tab>
              <Tab>Default Locations</Tab>
              {twitterImportsAvailable ? <Tab>Twitter Imports</Tab> : <></>}
            </Tabs>
            <Panes>
              <Pane>
                <div id="current-zcc-installations" className={styles.paneWrapper} />
              </Pane>
              <Pane>
                <div id="admin-management" className={styles.paneWrapper} />
              </Pane>
              <Pane>
                <div id="internal-admins-content" className={styles.paneWrapper} />
              </Pane>
              <Pane>
                <div id="default-locations-content" className={styles.paneWrapper} />
              </Pane>
              {twitterImportsAvailable
                ? <Pane><div id="twitter-imports-content" className={styles.paneWrapper} /></Pane>
                : <></>
              }
            </Panes>
          </TabbedPanes>
        </div>
      </ThemeProvider>
    );
  }
}

AdminSettings.propTypes = {
  defaultSelectedTab: PropTypes.number,
  selectedIndex: PropTypes.number,
  handleTabChange: PropTypes.func,
  onTabChange: PropTypes.func,
  styles: PropTypes.object,
};

AdminSettings.defaultProps = {
  defaultSelectedTab: 0,
  selectedIndex: 0
};

export default connect(mapStateToProps, actions, mergeProps)(themeable(AdminSettings));
